import dayjs from 'dayjs';

import {
  ProcessStatusDto,
  ResourceTypeDto,
  TasksSearchRequestDto,
  TaskStatusDto,
} from '@/api/generated';
import { SelectSearchOptionModel } from '@/components/form/model/SelectSearchOption.model.ts';
import { Override } from '@/utils/Override.utilityType.ts';

export type TasksListSearchFormModel = Override<
  TasksSearchRequestDto,
  {
    assignedUserId: Partial<SelectSearchOptionModel> | null;
    contextResourceTypes: SelectSearchOptionModel<ResourceTypeDto>[];
    creationDateFrom?: dayjs.Dayjs | null;
    creationDateTo?: dayjs.Dayjs | null;
    creatorUserId: Partial<SelectSearchOptionModel> | null;
    dueDateFrom?: dayjs.Dayjs | null;
    dueDateTo?: dayjs.Dayjs | null;
    status?: Partial<SelectSearchOptionModel<ProcessStatusDto>>;
    taskStatuses: SelectSearchOptionModel<TaskStatusDto>[];
    watchersUserIds?: SelectSearchOptionModel[];
  }
>;

export const initialTasksListSearchFormModel: TasksListSearchFormModel = {
  assignedUserId: null,
  contextResourceTypes: [],
  creatorUserId: null,
  taskStatuses: [],
  watchersUserIds: [],
};
